
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-gateway/ejar-fees",
      function () {
        return require("private-next-pages/payment-gateway/ejar-fees/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-gateway/ejar-fees"])
      });
    }
  